import { useNavigate } from "@tanstack/solid-router";

type Props = {
  /** When false, render the mark only (not a home control). Default: link to Home. */
  home?: boolean;
};

export function DebLogoMark(props: Props) {
  const navigate = useNavigate();
  const mark = (
    <img
      class="deb-logo-mark"
      src="/images/logo.svg"
      width={40}
      height={40}
      alt=""
    />
  );

  if (props.home === false) {
    return mark;
  }

  return (
    <button
      type="button"
      class="deb-logo-home"
      aria-label="Go to home"
      onClick={() => navigate({ to: "/" })}
    >
      <img
        class="deb-logo-mark"
        src="/images/logo.svg"
        width={40}
        height={40}
        alt="DataEngBytes"
      />
    </button>
  );
}
